import { useContext } from "react";
import structureContext from "../contexts/structureContext";

const useStructureContext = () => useContext(structureContext)

export default useStructureContext